// extracted by mini-css-extract-plugin
module.exports = {"container":"PumpDetails-module--container--2wJpf","alignRight":"PumpDetails-module--alignRight--1_BEt","alignLeft":"PumpDetails-module--alignLeft--W8jDM"};